<template>
  <div class="col col-12 h-100">
    <div class="col col-12" style="max-height: 100%!important; overflow: auto;">
      <table class="table table-sm table-borderless real_time_table">
        <thead class="table-headers text-center align-center thead">
          <tr>
            <th class="min_w">Future</th>
            <th class="min_w">Last</th>
            <th class="min_w" v-if="showFields">Change</th>
            <th class="min_w">% Change</th>
            <th class="min_w" v-if="showFields">Open</th>
            <th class="min_w">High</th>
            <th class="min_w">Low</th>
            <th class="min_w" v-if="showFields">Previous</th>
            <th class="min_w" v-if="showFields">Volume</th>
            <th class="min_w" v-if="showFields">Open Int</th>
            <th class="min_w" v-if="showFields">Updated</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(_, index) in skeletonTable.slice(0, nRows)"
            v-bind:key="index"
          >
            <td>
              <div class="row f-row" style="text-align: left;">
                <div class="col col-9 ml-2">M{{ index + 1 }}</div>
              </div>
            </td>
            <td>
              <div class="row f-row justify-content-center">
                <div class="col col-9">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td v-if="showFields">
              <div class="row f-row justify-content-center">
                <div class="col col-9">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td>
              <div class="row f-row justify-content-center">
                <div class="col col-9">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td v-if="showFields">
              <div class="row f-row justify-content-center">
                <div class="col col-9">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td>
              <div class="row f-row justify-content-center">
                <div class="col col-9">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td>
              <div class="row f-row justify-content-center">
                <div class="col col-9">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td v-if="showFields">
              <div class="row f-row justify-content-center">
                <div class="col col-9">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td v-if="showFields">
              <div class="row f-row justify-content-center">
                <div class="col col-9">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td v-if="showFields">
              <div class="row f-row justify-content-center">
                <div class="col col-9">
                  <Skeleton />
                </div>
              </div>
            </td>
            <td v-if="showFields">
              <div class="row f-row justify-content-center">
                <div class="col col-9">
                  <Skeleton />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getSkeletonTable } from "@/_core/_helpers/_helpers";
import Skeleton from "primevue/skeleton";

export default {
  name: "SkeletonSingleCommodity",
  components: {
    Skeleton
  },
  props: {
    nRows: { required: false, type: Number, default: 12 },
    showFields: { required: true, type: Boolean, default: true }
  },
  data() {
    return {
      skeletonTable: []
    };
  },
  created() {
    this.skeletonTable = getSkeletonTable();
  }
};
</script>

<style scoped>
.min_w {
  min-width: 60px;
}
</style>
